/** Voice 双栏布局 lg 断点：宽度 < 1024px 视为移动端（无右侧嵌入工作区） */
export const isVoiceMobileLayout = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(max-width: 1023px)').matches
}
